import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  connect() {
    this.element.addEventListener("keydown", this.submitOnEnter)

    this.element.querySelectorAll("input, select, textarea").forEach((el) => {
      el.addEventListener("change", this.submitNow)
    })
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.submitOnEnter)
    this.element.querySelectorAll("input, select, textarea").forEach((el) => {
      el.removeEventListener("change", this.submitNow)
    })
  }

  submitOnEnter = (event) => {
    if (event.key === "Enter") {
      const tag = event.target.tagName.toLowerCase()
      const type = event.target.type

      if (tag === "select" || type === "date" || type === "file") {
        event.preventDefault()
      }

      this.element.requestSubmit()
    }
  }

  submitNow = () => {
    this.element.requestSubmit()
  }
}
